<template>
    <div>
        <Breadcrumbs main="Shops" title="Main Report">
            <!-- <div class="form-group">
                <b-form-select @change="getReport" style="width:150px" v-model="report" :options="reportOptions"></b-form-select>
            </div> -->
        </Breadcrumbs>

        
        <!-- <div class="form-group">
            <b-form-select @change="getReport" style="width:150px" v-model="report" :options="reportOptions"></b-form-select>
        </div> -->
        <div class="container-fluid">
            <div class="row ">
              <div class="col-xl-8 box-col-12 xl-100">
                  <div class="row dash-chart">
                    <div class="col-xl-6 box-col-6 col-md-6">
                      <px-card slot="headerAction">
                        <div slot="headerCustom">
                          <div class="media">
                            <div class="media-body">
                                    <p><span class="f-w-500 font-roboto">Customer, Visit, Rate Graph</span>
                                      <!-- <span class="f-w-700 font-primary ml-2">89.21%</span> -->
                                    </p>
                                    <h4 class="f-w-500 mb-0 f-26"><span class="counter">Totals: {{ users.length+', '+visits.length+', '+rated }}</span></h4>
                                  </div>
                          </div>
                        </div>
                        <div>
                          <div class="media">
                            <div class="media-body">
                              <div class="profit-card">
                                <div id="spaline-chart">
                                  <apexchart
                                    height="150"
                                    type="area"
                                    :options="apexTotalsale.options"
                                    :series="apexTotalsale.series"
                                  ></apexchart>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </px-card>
                    </div>
                    <div class="col-xl-6 box-col-6 col-md-6">
                      <div class="card o-hidden">
                        <div class="card-header card-no-border">
                          <div class="card-header-right">
                            <ul class="list-unstyled card-option">
                              <li>
                                <i class="fa fa-spin fa-cog"></i>
                              </li>
                              <li>
                                <i class="view-html fa fa-code"></i>
                              </li>
                              <li>
                                <i class="icofont icofont-maximize full-card"></i>
                              </li>
                              <li>
                                <i class="icofont icofont-minus minimize-card"></i>
                              </li>
                              <li>
                                <i class="icofont icofont-refresh reload-card"></i>
                              </li>
                              <li>
                                <i class="icofont icofont-error close-card"></i>
                              </li>
                            </ul>
                          </div>
                          <div class="media">
                            <div class="media-body">
                              <p>
                                <span class="f-w-500 font-roboto"> Total Reviews</span>
                                <!-- <span class="f-w-700 font-primary ml-2">35.00%</span> -->
                              </p>
                              <h4 class="f-w-500 mb-0 f-26 counter">Total: {{ visits.filter(v=> v.comment !== "").length }}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="card-body pt-0">
                          <div class="monthly-visit">
                            <div id="column-chart">
                              <apexchart
                                height="105"
                                type="bar"
                                :options="apexTotalvisit.options"
                                :series="apexTotalvisit.series"
                              ></apexchart>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div class="col-xl-4 box-col-12 xl-50">
                  <div class="card o-hidden dash-chart">
                    <div class="card-header card-no-border">
                      <div class="card-header-right">
                        <ul class="list-unstyled card-option">
                          <li>
                            <i class="fa fa-spin fa-cog"></i>
                          </li>
                          <li>
                            <i class="view-html fa fa-code"></i>
                          </li>
                          <li>
                            <i class="icofont icofont-maximize full-card"></i>
                          </li>
                          <li>
                            <i class="icofont icofont-minus minimize-card"></i>
                          </li>
                          <li>
                            <i class="icofont icofont-refresh reload-card"></i>
                          </li>
                          <li>
                            <i class="icofont icofont-error close-card"></i>
                          </li>
                        </ul>
                      </div>
                      <div class="media">
                        <div class="media-body">
                          <p>
                            <span class="f-w-500 font-roboto">Totals</span>
                            <!-- <span class="font-primary f-w-700 ml-2">99.00%</span> -->
                          </p>
                          <!-- <h4 class="f-w-500 mb-0 f-26 mb-3">
                            <span class="counter">Totals</span>
                          </h4> -->
                          <!-- <h5>Rated <span class="txt-primary">{{ rated }}</span></h5> -->
                          <h5>Customers: <span class="txt-primary">{{ users.length }}</span></h5>
                          <h5>Visits: <span class="txt-primary">{{ visits.length }}</span></h5>
                          <h5>Products: <span class="txt-primary">{{ products.length }}</span></h5>
                          <p class="mb-0">Reviews: <span class="txt-primary">{{ visits ? visits.filter(v=> v.comment !== "").length : 0 }}</span></p>
                          <!-- <p class="mb-0">Contact us: <a href="tel:+233241026572">+233241026572</a></p> -->
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-0">
                      <div class="negative-container">
                        <div id="negative-chart">
                          <!-- <apexchart
                            height="320"
                            type="bar"
                            :options="apexTotalprofit.options"
                            :series="apexTotalprofit.series"
                          ></apexchart> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row second-chart-list third-news-update">
                      <div v-if="!userAdmin" class="col-xl-4 xl-50 appointment box-col-6">
                              <px-card :actions="false">
                                <div slot="headerCustom">
                                  <div class="header-top">
                                    <h5 class="m-0">Preferences</h5>
                                    <div class="card-header-right-icon">
                                      <select class="button btn btn-primary">
                                        <option>Year</option>
                                        <!-- <option>Tomorrow</option> -->
                                        <!-- <option>Yesterday</option> -->
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div class="radar-chart">
                                    <div id="marketchart">
                                      <apexchart
                                      v-if="pref"
                                        height="380"
                                        type="radar"
                                        :options="apexMarketValue.options"
                                        :series="apexMarketValue.series"
                                      ></apexchart>
                                    </div>
                                  </div>
                                </div>
                              </px-card>
                            </div>
                        </div>
        </div>


    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment';

    var primary = localStorage.getItem("primary_color") || "#7366ff";
    var secondary = localStorage.getItem("secondary_color") || "#f73164";

    export default {
        name: 'VendorReport',
        data() {
            return {
                reportOptions: [
                                    { value: null, text: 'Select Report' },
                                    // { value: 'T', text: 'Today' },
                                    // { value: 'W', text: 'This Week' },
                                    // { value: 'M', text: 'This Month' },
                                    { value: 'Y', text: 'This Year' },
                                    // { value: 'PW', text: 'Previous Week' },
                                    // { value: 'PM', text: 'Previous Month' },
                                    { value: 'PY', text: 'Previous Year' },
                            ],
                report: 'Y',
                items: [],
                users: null,
                visits: null,
                rated: 0,
                products: [],
                pref: null,
                apexTotalsale: {
                  options: {
                    chart: {
                      height: 150,
                      type: "area",
                      toolbar: {
                        show: false,
                      },
                    },
                    colors: [primary, secondary, '#a927f9'],
                    dataLabels: {
                      enabled: false,
                    },
                    stroke: {
                      curve: "smooth",
                      width: 0,
                    },
                    xaxis: {
                      // type: "datetime",
                      categories: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                      ],
                    },
                    yaxis: {
                      low: 0,
                      offsetX: 0,
                      offsetY: 0,
                      show: false,
                      labels: {
                        low: 0,
                        offsetX: 0,
                        show: false,
                      },
                      axisBorder: {
                        low: 0,
                        offsetX: 0,
                        show: false,
                      },
                    },
                    fill: {
                      type: "gradient",
                      opacity: [1, 0.6, 0.35],
                      gradient: {
                        shade: "light",
                        type: "horizontal",
                        shadeIntensity: 1,
                        gradientToColors: ["#a26cf8", "#a927f9", primary],
                        opacityFrom: [1, 0.4, 0.25],
                        opacityTo: [1, 0.4, 0.25],
                        stops: [30, 100],
                        colorStops: [],
                      },
                      colors: [primary, primary, primary],
                      // colors: [primary, primary],
                    },
                    tooltip: {
                      x: {
                        format: "dd/MM/yy HH:mm",
                      },
                    },
                    legend: {
                      show: false,
                    },
                    grid: {
                      show: false,
                      padding: {
                        left: 0,
                        right: -20,
                        top: 0,
                        bottom: -40,
                      },
                    },
                  },
                  series: [
                    {
                      name: "Customers",
                      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    },
                    {
                      name: "Visits",
                      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    },
                    {
                      name: "Rate",
                      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    },
                  ],
                },
                apexTotalvisit: {
                  options: {
                    chart: {
                      height: 105,
                      type: "bar",
                      stacked: true,
                      toolbar: {
                        show: false,
                      },
                    },
                    plotOptions: {
                      bar: {
                        dataLabels: {
                          position: "top", // top, center, bottom
                        },
                        columnWidth: "20%",
                        startingShape: "rounded",
                        endingShape: "rounded",
                      },
                    },
                    colors: [primary],
                    dataLabels: {
                      enabled: false,

                      formatter: function (val) {
                        return val + "%";
                      },
                      offsetY: -10,
                      style: {
                        fontSize: "12px",
                        colors: [primary],
                      },
                    },
                    xaxis: {
                      categories: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                      ],
                      position: "bottom",

                      axisBorder: {
                        show: false,
                      },
                      axisTicks: {
                        show: false,
                      },
                      crosshairs: {
                        fill: {
                          type: "gradient",
                          gradient: {
                            colorFrom: primary,
                            colorTo: secondary,
                            stops: [0, 100],
                            opacityFrom: 0.4,
                            opacityTo: 0.5,
                          },
                        },
                      },
                      tooltip: {
                        enabled: true,
                      },
                      labels: {
                        show: false,
                      },
                    },
                    yaxis: {
                      axisBorder: {
                        show: false,
                      },
                      axisTicks: {
                        show: false,
                      },
                      labels: {
                        show: false,
                        formatter: function (val) {
                          return val;
                        },
                      },
                    },
                    grid: {
                      show: false,
                      padding: {
                        top: -35,
                        right: -10,
                        bottom: -5,
                        left: -10,
                      },
                    },
                  },
                  series: [
                    {
                      name: "Reviews ",
                      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    },
                  ],
                },
                apexMarketValue: {
                  options: {
                    chart: {
                      width: 505,
                      height: 380,
                      type: "radar",
                      toolbar: {
                        show: false,
                      },
                    },
                    colors: [primary],
                    dataLabels: {
                      enabled: false,
                    },
                    labels: 
                    // this.getPrefs.map(p=> p.cat)
                    [
                      "Sunday",
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                    ]
                    ,
                    stroke: {
                      width: 3,
                      curve: "smooth",
                    },
                    plotOptions: {
                      radar: {
                        size: 140,
                        polygons: {
                          fill: {
                            colors: ["#fcf8ff", "#f7eeff"],
                          },
                        },
                      },
                    },
                    markers: {
                      size: 6,
                      colors: ["#fff"],
                      strokeColor: [primary],
                      strokeWidth: 3,
                    },
                    yaxis: {
                      tickAmount: 7,
                      labels: {
                        formatter: function (val, i) {
                          if (i % 2 === 0) {
                            return val;
                          } else {
                            return "";
                          }
                        },
                      },
                    },
                    tooltip: {
                      y: {
                        formatter: function (val) {
                          return val+'%';
                        },
                      },
                    },
                  },
                  series: [
                    {
                      name: "Market value",
                      data: [0, 0, 0, 0, 0, 0, 0],
                      // data: this.getPrefs.map(p=> p.value)
                    },
                  ],
                }
            }
        },
        computed: {
            userAdmin() {
            return localStorage.getItem('type') == "admin" ? true : false
            },
            getUser() {
            return this.$store.getters['authentication/getUser']
            },
            getPrefs() {

              const data = this.users

              let pref = []

              for (let index = 0; index < data.length; index++) {

                pref.push(data[index].preferences)
                                
              }

              let allpref = pref.flat()

              let array = []

              for (let index = 0; index < this.getUser.categories.length; index++) {
                //
                let c = 0;

                allpref.forEach(v=>v === this.getUser.categories[index] && c++)
                              
                array.push ({ cat: this.getUser.categories[index], value: (c/this.users.length) * 100 });

              }
                            
              array.sort(function(a, b) {
                return parseFloat(b.value) - parseFloat(a.value);
              });

              // this.pref = array

              return array

            },
        },
        watch: {
          pref() {
            if (this.pref) {
              this.apexMarketValue.options.labels = this.getPrefs.map(p=> p.cat)
              this.apexMarketValue.series[0].data = this.getPrefs.map(p=> p.value)
            }
          },
          users() {
            //
            if (this.users) {
              //
              let record1 = []

              this.getYear().forEach(month => {
                //
                record1.push(this.users.filter(u=> u.date.includes(month.substring(0,7))).length)
                
              });

              // this.apexTotalsale.options.labels = this.getPrefs.map(p=> p.cat)
              this.apexTotalsale.series[0].data = record1
              
            }
          },
          visits() {
            //
            if (this.visits) {
              let record2 = []
              let record3 = []
              let record4 = []
              
              this.getYear().forEach(month => {
                //
                const vs = this.visits.filter(v=> v.date.includes(month.substring(0,7)))
                //
                record2.push(vs.length)
                record3.push(this.visits.filter(v=> v.comment !== "" && v.date.includes(month.substring(0,7))).length)

                const rateLen = vs.length
                let vl = ((vs.reduce((a, b) => a + b.rate, 0)) / rateLen)

                //
                record4.push(vl ? vl.toFixed(1) : 0)

              });
              
              this.apexTotalsale.series[1].data = record2
              this.apexTotalsale.series[2].data = record4
              this.apexTotalvisit.series[0].data = record3
            }
          }
        },
        created() {
            // watch and fetch
            this.$watch(
            () => this.$route.$params,
            () => {
                this.fetchData()
            },
            { immediate: true }

            )

        },
        methods: {
          fetchData() {

            const url = this.userAdmin ? '/users/' : '/users/'+this.getUser.name

            axios.get(url)
              .then(response=>{
                //
                this.users = response.data

                let pref = []

                for (let index = 0; index < this.users.length; index++) {
                  

                  const shop = this.users[index].shops.find(shop => shop.shop == this.getUser.name)

                  if (shop) {
                      this.users[index].preferences = shop.preferences
                  }

                  pref.push(this.users[index].preferences)

                  this.users[index].date = this.userAdmin ? (new Date(this.users[index].createdAt)).toISOString() : (new Date(this.users[index].shops.find(s=>s.shop == this.getUser.name).createdAt)).toISOString()
                  
                }


                let allpref = pref.flat()

                let array = []

                for (let index = 0; index < this.getUser.categories.length; index++) {
                  //
                  let c = 0;

                  allpref.forEach(v=>v === this.getUser.categories[index] && c++)
                                
                  array.push ({ cat: this.getUser.categories[index], value: c });

                }
                              
                array.sort(function(a, b) {
                  return parseFloat(b.value) - parseFloat(a.value);
                });

                this.pref = array

                // return array


              })
              .catch( e => {
                this.$swal({
                  title:"Failed!",
                  text:e.response.data,
                  type:'error'
                });
              })

            axios.get('/Shop')
              .then(response=>{
                //
                this.shops = response.data

              })
              .catch( e => {
                this.$swal({
                  title:"Failed!",
                  text:e.response.data,
                  type:'error'
                });
              })

              const url2 = this.userAdmin ? '/visit/' : '/visit/'+this.getUser.name

            axios.get(url2)
              .then(response=>{
                //
                this.visits = response.data

                  for (let index = 0; index < this.visits.length; index++) {

                                // date
                                if (this.visits[index].createdAt) {
                                  this.visits[index].date = (new Date(this.visits[index].createdAt)).toISOString()
                                }
                                
                            }


                // if (!this.userAdmin) {
                //   for (let index = 0; index < this.visits.length; index++) {
                //       // const element = array[index];
                //       const rateLen = this.visits[index].rate.length

                //       if (rateLen > 0) {
                //       // sum rate
                //       const rate = (this.visits[index].rate.reduce((a, b) => a + b, 0)) / rateLen
                //       // to 2 decimalplaces
                //       this.visits[index].rate = parseFloat(rate.toFixed(1))

                //       // data.push(data[index])
                //       } else {
                //         this.visits[index].rate = 0
                //       }
                //   }
                // }

                const rateLen = this.visits.length

                //
                this.rated = ((response.data.reduce((a, b) => a + b.rate, 0)) / rateLen).toFixed(1)

              })
              .catch( e => {
                this.$swal({
                  title:"Failed!",
                  text:e.response.data,
                  type:'error'
                });
              })


              const url3 = this.userAdmin ? '/products/' : '/products/'+this.getUser.name

              axios.get(url3)
                .then(response=>{
                  //
                  this.products = response.data

                })
                .catch( e => {
                  this.$swal({
                    title:"Failed!",
                    text:e.response.data,
                    type:'error'
                  });
                })
            },
            getYear(year) {

            var firstmonth = year ? year+"-01-01" :  new Date().getFullYear()+"-01-01"
            // var lastday = new Date(curr.setDate(last)).toDateString().substring(4);

            let months =[]
            //
            for (let index = 0; index < 12; index++) {

              const d = moment(firstmonth).add(index, 'months').toDate().toISOString().substring(0,10)
              
              months.push(d)
            }

            // console.log(days)
            return months

            }
        }
    }
</script>

<style lang="scss" scoped>

</style>